import { Injectable } from '@angular/core';

@Injectable()
export class EulaService {

    private eulaDisplayed: boolean = false;

    public enableEulaDisplay(eulaDisplayed: boolean) {
        this.eulaDisplayed = eulaDisplayed;
    }

    public isEulaDisplayed(): boolean {
        return this.eulaDisplayed;
    }
}
